const configuredEnvironment = window['environment'];

export const environment = Object.assign(
  {
    apiUrl: '/capweb/api',
    kanton: 'BI',
    openIdConnect: {
      issuer: 'https://localhost:8080/auth/realms/capitastra',
      clientId: 'capitastra-client',
      noSSL: false,
      idpHint: undefined,
      postLogoutRedirectUri: undefined
    },
    clientLevel: 'all',
    serverLevel: 'all',
    bbvEnabled: false,
    deploymentMode: 'PUBLIC',
    versionNr: '',
    mizenBasePath: '',
    gwrServerUrl: ''
  },
  configuredEnvironment
); // durch assets/environment.js gesetzt
